const solution = 'beltrame_steel_decarbon';
const snackbar_config = {
  snackbar_duration: 2000,
  snackbar_error_duration: 10000,
};
const bypass_auth_token_resources = [
  'https://diasbeltramestorage.blob.core.windows.net/', 
  'https://api.powerbi.com'
];

export const GLOBAL_CONFIG = {
  solution,
  snackbar_config,
  bypass_auth_token_resources,
};